const benefits = [
  { icon: "ri-flashlight-line", label: "Fast Discovery" },
  { icon: "ri-arrow-left-right-line", label: "Price Compare" },
  { icon: "ri-user-star-line", label: "Trusted Agents" },
  { icon: "ri-timer-line", label: "Daily Updates" },
  { icon: "ri-safe-2-line", label: "Safe Buying" },
];

export default function AboutDarkSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-foreground-950">
      <div className="max-w-[960px] mx-auto px-4 md:px-6 text-center">
        <p className="text-xs font-label font-semibold uppercase tracking-wider text-background-50/50 mb-4">
          Why MuleBuy Spreadsheet Matters
        </p>

        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-8">
          The Smarter Way to
          <br />
          Discover Products Online
        </h2>

        <p className="text-base md:text-lg text-background-50/60 max-w-[640px] mx-auto mb-12 leading-relaxed">
          A <strong className="text-background-50/80">mulebuy spreadsheet</strong> is a structured product listing system that helps users discover, compare, and purchase products through China-based shopping agents more efficiently. It simplifies product discovery, price comparison, agent selection, and bulk ordering decisions &mdash; all in one organized place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-foreground-950 font-label font-semibold text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            MuleBuy Spreadsheet
            <i className="ri-external-link-line text-base"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-background-50/30 text-background-50 font-label font-semibold text-sm cursor-pointer hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-external-link-line text-base"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {benefits.map((benefit) => (
            <div
              key={benefit.label}
              className="bg-foreground-900 rounded-xl p-4 md:p-5 flex flex-col items-center gap-3"
            >
              <div className="w-10 h-10 rounded-lg bg-foreground-800 flex items-center justify-center">
                <i className={`${benefit.icon} text-background-50/70 text-lg`}></i>
              </div>
              <span className="text-xs md:text-sm font-label font-medium text-background-50/80 whitespace-nowrap">
                {benefit.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}